/* eslint-disable camelcase */
import { invisiblyApi } from '../../../redux/api/invisibly-api';
import { InvisiblyApiResponse } from '../../../services/api/api-response.types';
import { PostalCodeGeocodeResult } from '../types/zipcode.types';

const geocodeEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    getZipcodeGeocode: builder.query<PostalCodeGeocodeResult[], { zipcodes: string[] }>({
      query: ({ zipcodes }) => ({
        method: 'GET',
        url: `geocode/zipcode/${zipcodes.join(',')}`,
      }),
      transformResponse(response: InvisiblyApiResponse<PostalCodeGeocodeResult[]>) {
        return response.item;
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetZipcodeGeocodeQuery,
} = geocodeEndpoints;